import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import PlusIcon from 'icons/Plus.icon';
import InputField from 'components/InputField';
import validations from 'validations';
import { Button } from 'ncoded-component-library';
import { FormApi } from 'final-form';

import './AddNewOption.styles.scss';

type AddNewOptionProps = {
  className?: string;
  onAdd: (values: Record<string, any>, form: FormApi) => void;
};

const AddNewOption: React.FC<AddNewOptionProps> = (props) => {
  const { className, onAdd } = props;

  const classes = classNames('add-new-option', className);

  const { t } = useTranslation();

  return (
    <Form
      onSubmit={onAdd}
      render={({
        valid,
        submitting,
        values: { name },
        form: { reset },
        handleSubmit,
      }) => (
        <form className={classes} onSubmit={handleSubmit}>
          <div className="add-new">
            <PlusIcon />
            <Field
              name="name"
              placeholder={t('addNew') + '...'}
              component={InputField}
              showErrorMsg={false}
              validate={validations.composeValidators(
                validations.required(),
                validations.minLength('min', 2),
                validations.maxLength('max', 100),
              )}
            />
          </div>

          {valid && (
            <Button variant="outline" type="submit" disabled={submitting}>
              {t('save')}
            </Button>
          )}

          {name && (
            <Button variant="link" onClick={() => reset()}>
              {t('cancel')}
            </Button>
          )}
        </form>
      )}
    />
  );
};

export default AddNewOption;
